import React from "react";
import "./Testimonials.css";
import testimonialData from './Data'; 
import images from "../../../Utils/Images";
import posthog from "posthog-js";

const Testimonials = () => {

  const showTestimonials = posthog.isFeatureEnabled("testimonials_section");

  if (!showTestimonials) return null;

  const displayData = [
    ...testimonialData, 
    ...testimonialData, 
    ...testimonialData
  ];

  return (
    <section className="testimonialSection">
      <div className="testimonialContent">
        <h1>
          Don’t just trust us,<br/> 
          <span>Hear it from them.</span>
        </h1>

        <p>
          What our customers say about our work
        </p>
      </div>

      <div className="testimonialContainer">
        <div className="testimonialGrid">
          {displayData.map((testimonial, index) => (
            <div key={index + testimonial.name} className="testimonialCard">
              <div className="testimonialCardHeader">
                <img 
                  src={images.avatar} 
                  alt={`${testimonial.name}`} 
                  className="testimonialAvatar" 
                />
                <div className="testimonialUserInfo">
                  <p className="testimonialName">
                    {testimonial.name}
                  </p>
                  <p className="testimonialHandle">{testimonial.handle}</p>
                </div>
              </div>
              <p className="testimonialText">
                {testimonial.text}
                <br />
                Thanks 
                <span className="testimonialMention"> @{testimonial.mention}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;